module.exports = __webpack_public_path__ + "img/2 (4).576931f7.jpg";